import React from 'react'

import styles from './person-articles-card.module.css'
import { Image } from '../Image'
import { Link } from 'gatsby'
import { isExternalUrl } from '../../lib/helpers'

const PersonArticlesCard = ({ image, logo, title, category = [], link, publishedAt }) => {
  const hasProtocol = link && (link.startsWith('http://') || link.startsWith('https://'))
  const external = hasProtocol && isExternalUrl(link)
  const CardWrapper = external ? 'a' : Link
  const cardProps = external
    ? { href: link, target: '_blank', rel: 'noreferrer' }
    : { to: link }

  return (
    <CardWrapper {...cardProps} className={`${styles.personFeaturingCard} ${logo ? styles.hasLogo : ''}`}>
      <div className={styles.imageWrap}>
        <Image imgObj={image} className={styles.image} props={{ width: '392', height: '221' }} />
        {logo && <Image imgObj={logo} className={styles.logo} />}
      </div>
      <div className={styles.category}>
        {category.join(', ')}
      </div>
      <div className={styles.title}>
        {title}
      </div>
    </CardWrapper>
  )
}

export default PersonArticlesCard
